<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择产线"
      top="8vh"
      width="800px"
  >
    <view-table
        ref="viewTable"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        url="fm/production-mangeline"
        :tool-bar-show="false"
        :table-action="false"
        :table-select="false"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter">
          <el-form-item label="产线编码">
            <el-input v-model.trim="filter.lineCode" placeholder="请输入产线编码" clearable/>
          </el-form-item>
          <el-form-item label="产线全称">
            <el-input v-model.trim="filter.lineName" placeholder="请输入产线全称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <div slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "ProductionLineSelect",
    components: { ViewTable },
    data() {
      return {
        dialogVisible: false,
        filter: {
          lineCode: "",
          lineName: "",
        },
        columnsProperty: [
          {
            key: "lineCode",
            align: "center",
            width: 140,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: { color: "#2d8cf0", cursor: "pointer", fontWeight: "bold" },
                  on: {
                    click: () => this.selectRow(params.row),
                  },
                },
                params.row.lineCode
              );
            },
          },
          { key: "lineName", minWidth: 200 },
          { key: "lineShortName", width: 120, align: "center" },
          { key: "lineTypeName", width: 110, align: "center" },
          { key: "lineStatusName", width: 110, align: "center" },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.viewTable && this.$refs.viewTable.loadData(1);
        });
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      selectRow(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },
    },
  };
</script>
